"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Field = _interopRequireDefault(require("../Field"));
var _CheckboxInput = _interopRequireDefault(require("../CheckboxInput"));
var _RadioInput = _interopRequireDefault(require("../RadioInput"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * The props for the Input component.
 */

/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Input](https://docs.vanillaframework.io/base/forms/#input).
 *
 * An input field where the user can enter data, which can vary in many ways, depending on the type attribute.
 */
const Input = _ref => {
  let {
    caution,
    className,
    error,
    help,
    helpClassName,
    id,
    label,
    labelClassName,
    required,
    stacked,
    success,
    takeFocus,
    takeFocusDelay,
    type,
    wrapperClassName,
    ...inputProps
  } = _ref;
  const inputRef = (0, _react.useRef)(null);
  const fieldLabel = !["checkbox", "radio"].includes(type) ? label : "";
  const defaultInputId = (0, _react.useId)();
  const inputId = id || defaultInputId;
  const validationId = (0, _react.useId)();
  const helpId = (0, _react.useId)();
  const hasError = !!error;
  const description = [help ? helpId : null, success ? validationId : null].filter(Boolean).join(" ");
  const commonProps = {
    "aria-describedby": !description ? undefined : description,
    "aria-errormessage": hasError ? validationId : null,
    "aria-invalid": hasError,
    id: inputId,
    required: required,
    ...inputProps
  };
  (0, _react.useEffect)(() => {
    if (takeFocus) {
      if (takeFocusDelay) {
        setTimeout(() => inputRef.current.focus(), takeFocusDelay);
      } else {
        inputRef.current.focus();
      }
    }
  }, [takeFocus, takeFocusDelay]);
  let input;
  if (type === "checkbox") {
    input = /*#__PURE__*/_react.default.createElement(_CheckboxInput.default, _extends({
      label: label,
      labelClassName: labelClassName
    }, commonProps));
  } else if (type === "radio") {
    input = /*#__PURE__*/_react.default.createElement(_RadioInput.default, _extends({
      label: label,
      labelClassName: labelClassName
    }, commonProps));
  } else {
    input = /*#__PURE__*/_react.default.createElement("input", _extends({
      className: (0, _classnames.default)("p-form-validation__input", className),
      ref: inputRef,
      type: type
    }, commonProps));
  }
  return /*#__PURE__*/_react.default.createElement(_Field.default, {
    caution: caution,
    className: wrapperClassName,
    error: error,
    forId: inputId,
    help: help,
    helpClassName: helpClassName + "",
    helpId: helpId,
    isTickElement: type === "checkbox" || type === "radio",
    label: fieldLabel,
    labelClassName: labelClassName,
    required: required,
    stacked: stacked,
    success: success,
    validationId: validationId
  }, input);
};
var _default = exports.default = Input;